export default "__VITE_ASSET__BxwLbnTv__"